import {
    SET_ACCOUNTS,
    SET_BACKFILLS,
    SELECT_INTEGRATION,
    SELECT_INTEGRATION_ACCOUNT, SET_FACILITIES, SET_UPDATED_FACILITY
} from "../../constants.js";
import {setCookie, isEmpty} from "weed-js";

const defaultState = {
    totalIntegrations: 0,
    selectedIntegration: null,
    accounts: {
        selectedAccounts: [],
        metrc: [],
        dutchie: [],
        alpineiq: []
    },
    syncs: {
        metrc: [],
        dutchie: [],
        alpineiq: []
    }
};

const IntegrationReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SELECT_INTEGRATION_ACCOUNT:
        setCookie("integrationAccountIds", JSON.stringify(action.value.map(option => option.id)));
        return {
            ...state,
            accounts: {
                ...state.accounts,
                selectedAccounts: isEmpty(action) ? [] : action.value
            }
        };
    case SET_UPDATED_FACILITY:
        let updatedState = {...state};
        updatedState["accounts"][action.namespace] = state["accounts"][action.namespace].map(account => {
            if (account.id === action.facility.account_id) {
                account.facilities = account.facilities.map(facility => {
                    if (facility.id === action.facility.id) {
                        return action.facility;
                    }
                    return facility;
                });
            }
            return account;
        });

    case SET_FACILITIES:
        const integrationAccountsById = state.accounts[action.namespace].reduce((acc, account) => {
            acc[account.id] = account;
            return acc;
        }, {});
        action.facilities.map(facility => {
            const account = integrationAccountsById[facility.account_id];
            if (account) {
                if (!account.hasOwnProperty("facilities")) {
                    account.facilities = [];
                }
                if (!account.facilities.find(f => f.id === facility.id)) {
                    account.facilities.push(facility);
                }
            }
        });
        return {
            ...state,
            accounts: {
                ...state.accounts,
                [action.namespace]: state.accounts[action.namespace]
            }
        };
    case SELECT_INTEGRATION:
        if (isEmpty(action)) {
            setCookie("integration", "");
        } else {
            setCookie("integration", action.value);
        }
        if (!isEmpty(state.accounts.selectedAccounts)) {
            if (isEmpty(action) || isEmpty(action.value) || action.value.id !== state.selectedIntegration?.id) {
                setCookie("integrationAccountId", "");
                return {
                    ...state,
                    selectedIntegration: isEmpty(action) ? null : action.value,
                    accounts: {
                        ...state.accounts,
                        selectedAccounts: []
                    }
                };
            }
        }
        return {
            ...state,
            selectedIntegration: action.value
        };
    case SET_ACCOUNTS:
        const previous = state.accounts[action.namespace].length;
        const current = isEmpty(action.accounts) ? 0 : action.accounts.length;
        const accounts = [...state.accounts[action.namespace], ...action.accounts].filter((account, index, self) =>
            index === self.findIndex((t) => (
                t.id === account.id
            ))
        );
        return {
            ...state,
            totalIntegrations: state.totalIntegrations - previous + current,
            accounts: {
                ...state.accounts || [],
                [action.namespace]: accounts
            }
        };
    case SET_BACKFILLS:
        return {
            ...state,
            backfills: {
                ...state.backfills,
                [action.namespace]: action.backfills
            }
        };
    default:
        return state;
    }
};


export default IntegrationReducer;
